import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'

export interface SignoutResponse extends Response {
	msg: string
}

export const signout = async (): Promise<SignoutResponse> => {
	const response = await client.delete<SignoutResponse>(`auth/signout`)

	return response.data
}
